import React from "react";
import { Row, Col } from "reactstrap";
import Scheduler from "./Scheduler";

const Appointment = () => {
  //2. create the view model, put it in the props obj

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h1>Appointment</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Scheduler />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Appointment;
